<template>
  <div>
    <div id="loginbox">
      <!-- <img src="@/assets/img/baidu/indexbg.jpg" /> -->

      <van-form class="bform" ref="form" @submit="submit">
        <van-field
          class="bform-input"
          placeholder="请输入兑换码"
          v-model="form.redeemCode"
          name="redeemCode"
          :rules="[
            {
              required: true,
              message: '请输入兑换码'
            }
          ]"
        />
        <van-field
          class="bform-input"
          placeholder="请输入手机号码"
          v-model="form.phone"
          name="phone"
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="bform-input yzm"
          placeholder="请输入验证码"
          v-model="form.captchaCode"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="sendCode">获取验证码</div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button class="submit" :loading="loading" native-type="submit">
          去兑换
        </van-button>
      </van-form>
    </div>
    <!-- 确认弹框 -->
    <van-dialog
      v-model="confirmVisible"
      :showConfirmButton="false"
      closeable
      class="reset-dialog"
    >
      <img class="police" src="@/assets/img/baidu/police.png" />
      <img class="tip" src="@/assets/img/baidu/tip.png" />
      <img
        class="close"
        src="@/assets/img/baidu/close.png"
        @click="confirmVisible = false"
      />
      <div class="txt">
        任何平台/任何人主动联系叫您拍链接的，让扫描二维码下单，让您刷单返利都是骗局。通过第三方链接（游戏和其他充值、会员续费，交易猫、闲鱼等），跳转外链下单的均为诈骗！让您发送含有卡密信息的截图兑换页的或让提供卡号卡密的都是为了骗取您的卡密！！！请不要相信！！！有任何疑问请优先联系本店在线客服！
      </div>
      <div class="operations">
        <van-button
          color="linear-gradient(90deg, #33FFFE, #0DB5FF, #0170E8)"
          @click="confirmSubmit()"
          v-if="!confirmTime"
        >
          确认
        </van-button>
        <!-- 确认倒计时 -->
        <van-button color="#C6C9CE" v-if="confirmTime">
          确认
          <van-count-down
            class="confirmdown"
            format="(sss)"
            :time="confirmTime"
            @finish="confirmTime = 0"
          />
        </van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { baiduCheck, getCaptcha } from '@/api/baidu.js'
export default {
  data() {
    return {
      time: 0,
      loading: false,
      form: {
        redeemCode: undefined,
        phone: undefined,
        captchaCode: null
      },
      confirmVisible: false,
      confirmTime: 0
    }
  },
  methods: {
    async confirmSubmit() {
      try {
        this.confirmTime = 0
        this.confirmVisible = false
        this.loading = true
        const { code, data, message } = await baiduCheck({
          ...this.form,
          customerNo: this.$route.query?.customerNo || undefined
        })
        this.loading = false
        switch (code) {
          case 0:
            this.$router.push({
              path: '/baiduList',
              query: { token: data }
            })
            break
          default:
            this.$toast.fail({
              message: message
            })
            break
        }
      } catch (error) {
        this.loading = false
      }
    },
    async submit() {
      this.confirmTime = 15000
      this.confirmVisible = true
    },
    async sendCode() {
      await this.$refs.form.validate('redeemCode')
      await this.$refs.form.validate('phone')
      const { code, message } = await getCaptcha({
        ...this.form,
        customerNo: this.$route.query?.customerNo || undefined
      })
      if (code === 0) {
        this.time = 60000
      } else {
        this.$toast.fail({
          message: message
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-field__control::placeholder,
/deep/.van-field--error .van-field__control::placeholder {
  color: #929fb5;
}
#loginbox {
  min-height: 100vh;
  background: #f5f8fd url('~@/assets/img/baidu/indexbg.png') top center
    no-repeat;
  background-size: 100% auto;
  .bform {
    padding: 800px 64px 40px;
    box-sizing: border-box;
    border-radius: 15px;
    .bform-input {
      border: solid 1px #bbcae3;
      line-height: 104px;
      margin-bottom: 34px;
      width: 100%;
      box-sizing: border-box;
      border-radius: 20px;
      padding: 0 10px 0 40px;
      font-size: 32px;
    }
    .yzm {
      display: flex;
      padding: 0 40px;
    }
    /deep/ .van-field__error-message {
      line-height: 60px;
    }
    .submit {
      width: 100%;
      height: 104px;
      background: linear-gradient(90deg, #33fffe, #0db5ff, #0170e8);
      border-radius: 20px;
      text-align: center;
      color: #ffffff;
      font-size: 40px;
    }
  }
  .cdown {
    flex: 1;
    text-align: center;
    color: #3c6aba;
    box-sizing: border-box;
    padding-left: 3.77vw;
    position: relative;
    &::after {
      position: absolute;
      content: '|';
      left: 0;
      top: 0;
    }
  }
}
.reset-dialog {
  background: linear-gradient(0deg, #ffffff, #ebf2ff, #b2d0ff), #fff;
  background-size: 100% 70%, 100% 100%;
  background-repeat: no-repeat, no-repeat;
  border-radius: 40px;
  padding: 150px 60px 60px;
  z-index: 999;
  overflow: visible;
  .police {
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    width: 140px;
    z-index: 10;
  }
  .tip {
    width: 436px;
    display: block;
    margin: 0 auto 64px;
  }
  .close {
    position: absolute;
    right: 30px;
    top: 30px;
    width: 50px;
  }
  .txt {
    font-size: 28px;
    color: #000000;
    line-height: 48px;
  }
  .operations {
    .van-button {
      width: 360px;
      display: block;
      margin: 70px auto 0;
      border-radius: 20px;
      box-sizing: border-box;
      font-size: 36px;
      padding: 0;
    }
    .confirmdown {
      display: inline;
      color: #fff;
    }
  }
}
</style>
